import {i18n} from '@yourcoach/i18n';

import type {ValidationRule} from './types';

export const getUserNameSchema: () => ValidationRule = () => ({
  max: 255,
  messages: {
    required: i18n.t('shared:validation.user_name_required'),
    stringMax: i18n.t('shared:validation.name_max_length', {
      maxLength: 255,
    }),
  },
  type: 'string',
});

export const getTitleSchema: () => ValidationRule = () => ({
  max: 255,
  messages: {
    required: i18n.t('shared:validation.title_required'),
    stringMax: i18n.t('shared:validation.title_max_length', {
      maxLength: 255,
    }),
  },
  type: 'string',
});

export const getDescriptionSchema: () => ValidationRule = () => ({
  max: 10000,
  messages: {
    stringMax: i18n.t('shared:validation.description_max_length', {
      maxLength: 10000,
    }),
  },
  optional: true,
  type: 'string',
});

export const getEmailSchema: () => ValidationRule = () => ({
  messages: {
    email: i18n.t('shared:validation.email_not_valid'),
    required: i18n.t('shared:validation.email_required'),
  },
  mode: 'precise',
  type: 'email',
});

export const getPhoneSchema: () => ValidationRule = () => ({
  messages: {
    required: i18n.t('shared:validation.phone_required'),
    stringPattern: i18n.t('shared:validation.phone_not_valid'),
  },
  pattern: /^\+\d{4,13}$/,
  type: 'string',
});

export const getCodeSchema: () => ValidationRule = () => ({
  messages: {
    required: i18n.t('shared:validation.code_required'),
    stringPattern: i18n.t('shared:validation.code_not_valid'),
  },
  pattern: /^\d{6}$/,
  type: 'string',
});
